module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAfUlEQVQ4y2NgGBTgPxR8ff8RjK/sPvZ/om/m/zxRq/8FkrY4MYYBYPDv//87xy/8nxyYQ5kBU4JzyTfg7omLYBfkkmvA7aPn/k8CeUGMTANuHT77f5J/NgVhcOz8/0kBOZSHAWXRSEkskJ0OwCnx3cf/V0Ep0S+LeAOGNgAAT+qJAS5aQBAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/QA.png
// module id = 1249
// module chunks = 0